import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function FavoriteIcon(props) {
  return (
    <SvgIcon viewBox="0 0 60 60" {...props}>
      <title>Favorite</title>
      <g>
        <path d="M30 53.375L26.375 50.075C13.5 38.4 5 30.7 5 21.25C5 13.55 11.05 7.5 18.75 7.5C23.1 7.5 27.275 9.525 30 12.725C32.725 9.525 36.9 7.5 41.25 7.5C48.95 7.5 55 13.55 55 21.25C55 30.7 46.5 38.4 33.625 50.1L30 53.375Z" />
      </g>
    </SvgIcon>
  );
}

export default FavoriteIcon;
